import React from 'react';
import {View, ViewStyle} from 'react-native';
import {Sizes, Colors, Shadows} from '../index';
import {ComponentProps} from './ComponentProps';

interface CardProps extends ComponentProps {
  borderColor: string;
  backgroundColor: string;
  containerStyle?: ViewStyle;
}

export const CardDefault = (props: React.PropsWithChildren<ComponentProps>) => {
  return (
    <Card backgroundColor={Colors.brandWhite} borderColor={Colors.neutralLighter}>
      {props.children}
    </Card>
  );
};

export const Card = (props: React.PropsWithChildren<CardProps>) => {
  const containerStyle: ViewStyle[] = [
    Shadows.default,
    {
      flexDirection: 'row',
      borderWidth: 1,
      borderRadius: Sizes.s,
      backgroundColor: props.backgroundColor,
      borderColor: props.borderColor,
    },
  ];
  return (
    <View style={props.containerStyle}>
      <View style={containerStyle} testID={props.testID}>
        {props.children}
      </View>
    </View>
  );
};
